<div class="wrapper__form container mt-5 mb-3 border__form">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <h2 class="mb-0">{{ 'validacion_documentos.titulo' | translate }}</h2>
    </div>
  </div>

  <p>{{ 'validacion_documentos.mensaje_instrucciones' | translate }}</p>

  <div class="carga-archivo text-center p-4 border rounded"
       (dragover)="onDragOver($event)"
       (drop)="onFileDrop($event)"
       (dragleave)="onDragLeave($event)">
    <input type="file" id="archivo" (change)="onFileSelected($event)" hidden>
    <label for="archivo" class="btn btn-outline-primary">{{ 'validacion_documentos.archivo_buscar' | translate }}</label>
    <p class="mt-2">{{ 'validacion_documentos.archivo_arrastrar' | translate }}</p>
    <p class="text-muted">{{ 'validacion_documentos.archivo_tamano' | translate }}</p>
  </div>

  <!-- Vista previa del archivo -->
  <div *ngIf="vistaPreviaUrl" class="text-center mt-3">
    <p><strong>{{ 'validacion_documentos.vista_previa' | translate }}</strong></p>
    <ng-container *ngIf="archivoSeleccionado?.type === 'application/pdf'; else imagen">
      <iframe [src]="vistaPreviaUrl" width="100%" height="400px"></iframe>
    </ng-container>
    <ng-template #imagen>
      <img [src]="vistaPreviaUrl" alt="Vista previa" class="img-fluid" style="max-width: 100%; max-height: 400px;">
    </ng-template>
  </div>

  <div class="text-center mt-4">
    <button class="btn btn-primary" [disabled]="!archivoSeleccionado" 
    (click)="validarArchivo()"
    [attr.aria-label]="'validacion_documentos.btn_validar' | translate">
      {{ 'validacion_documentos.btn_validar' | translate }}
    </button>
  </div>
</div>
